// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SchemaForm } from "@components";
import { uiSchema } from "./ui-schema";

type OwnProps = $Exact<{
  onRef: (ref: *) => void,
  data: Object,
  schema: Object,
  onChange: Function,
  onSubmit: Function,
  editing?: boolean,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class RtwNotifications extends React.Component<Props> {
  render() {
    return (
      <div className="w-100 d-flex justify-content-center">
        {this.props.data ? (
          <SchemaForm
            ref={ref => this.props.onRef(ref)}
            className="w-100"
            formData={this.props.data}
            schema={this.props.schema}
            onChange={this.props.onChange}
            onSubmit={this.props.onSubmit}
            uiSchema={uiSchema(this.props.t)}
            externalSubmit
          >
            <div className="d-flex justify-content-center" />
          </SchemaForm>
        ) : null}
      </div>
    );
  }
}

export default localize()(RtwNotifications);
